import { axiosHelper } from "../utils/axiosHelper";

export async function fetchAnnounce() {
  return await axiosHelper.get("/api/Announce");
}
